import { atom } from 'recoil';

import { CONTROLLERS_VISIBLE } from 'store/constants';

export const AControllersVisible = atom<boolean>({
  key: CONTROLLERS_VISIBLE,
  default: false,
});
